// extracted by mini-css-extract-plugin
export default {"loadingContainer":"MappingTemplate_loadingContainer__TGQQR"};